import React from "react"

const CookieModal: React.FC<any> = ({ acceptCookies }) => {
    return (
        <div className='onlinepbx__cookie__modal'>
            <div className='onlinepbx__cookie__modal__text'>
                Оставаясь на сайте, вы соглашаетесь с нашей <a className='onlinepbx__cookie__modal__link' href='https://www.onlinepbx.ru/privacy/conf.pdf' target='_blank' rel='noopener noreferrer'>политикой обработки персональных данных</a> и с применением нами файлов cookie.
            </div>
            <button onClick={acceptCookies} className='onlinepbx__cookie__modal__button'>Принять</button>
        </div>
    )
}

export default CookieModal